module.exports = __webpack_public_path__ + "static/preview-image-31a0b3dabc790cb53ff27027c322e55b.jpg";